import styles from './styles.scss';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import loading from '../../../../../../static/animations/paymentLoading.json';
import success from '../../../../../../static/animations/paymentSucces.json';
import error from '../../../../../../static/animations/paymentError.json';
import cn from 'classnames';
// eslint-disable-next-line import/no-extraneous-dependencies
import Lottie from 'lottie-react';
import TicketButton from 'widget/event_components/Ticket/components/Button';

export const PaymentModalStatuses = {
  SUCCESS: 'success',
  ERROR: 'error',
  LOADING: 'loading',
};

const PaymentStatusModal = ({ status, message, onClick }) => {
  const animation = useMemo(() => {
    if (status === PaymentModalStatuses.ERROR) return error;
    if (status === PaymentModalStatuses.SUCCESS) return success;
    return loading;
  }, [status]);

  const title = useMemo(() => {
    if (status === PaymentModalStatuses.ERROR) return 'Credit Card Error';
    if (status === PaymentModalStatuses.SUCCESS) return 'Payment Success!';
    return 'Checking Your Card';
  }, [status]);

  const modalMessage = useMemo(() => {
    if (status === PaymentModalStatuses.LOADING) return '';

    if (status === PaymentModalStatuses.ERROR) {
      if (process.env.NODE_ENV !== 'development') {
        return message;
      }
      return 'Oops! Server error. Try to pay later or change you credit card credentials';
    }

    return message || '';
  }, [status]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>{title}</div>
      <Lottie className={styles.lottieStyled} animationData={animation} loop={status === PaymentModalStatuses.SUCCESS || !status} />
      <div className={cn(styles.message, { [styles.show]: !!message })}>{modalMessage}</div>
      {status !== PaymentModalStatuses.LOADING && (
        <TicketButton onClick={onClick}>{status === PaymentModalStatuses.ERROR ? 'Try later' : 'Back to Events'}</TicketButton>
      )}
    </div>
  );
};

PaymentStatusModal.propTypes = {
  status: PropTypes.string.isRequired,
  message: PropTypes.node,
};

export default PaymentStatusModal;
